module.exports = __webpack_public_path__ + "e3d972ba7de1f9505545f81eef44c26c.svg";